import { Card, CardActions, CardContent, CardMedia, Grid, Typography, Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const SingleProject = ({project}) => {
    const {_id, name, description, img} = project;
    return (
            <Grid item xs={12} md={4}>
                <Card sx={{ maxWidth: 345 }}>
                    <CardMedia
                        component="img"
                        height="194"
                        image={img}
                        alt="Paella dish"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                        {name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                        {description}
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Link to={`/viewproject/${_id}`}>
                            <Button variant="outlined" size="small">Learn More</Button>
                        </Link>
                    </CardActions>
                </Card>
            </Grid>
    );
};

export default SingleProject;